import { Link } from "react-router-dom"
import ProfileMenu from "./ProfileMenu"
import { invalidateQueriesForStatisticsAboutYoungsWithAttendance } from "@/entities/user/useYoung"

export default function Navbar({ onGlobalMenuOpen }: { onGlobalMenuOpen: () => void }) {
   return (
      <div className="navbar bg-base-100 shadow-lg sticky top-0 z-10">
         <div className="flex-none">
            <button className="btn btn-square btn-ghost" onClick={onGlobalMenuOpen}>
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block h-5 w-5 stroke-current"
               >
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth="2"
                     d="M4 6h16M4 12h16M4 18h16"
                  ></path>
               </svg>
            </button>
         </div>
         <div className="flex-1">
            <Link
               to="/"
               onClick={() => {
                  invalidateQueriesForStatisticsAboutYoungsWithAttendance(true)
               }}
               className="btn btn-ghost normal-case text-xl"
            >
               <img className="h-6 mr-2" src="/tela-logo.png" alt="Logo de Télà?" />
               Télà?
            </Link>
         </div>
         <div className="flex-none">
            <ProfileMenu />
         </div>
      </div>
   )
}
